
































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import LicenceBody from "./LicenceBody.vue";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { CustomerArticleLicenceDTO } from "../../Generated/ParticaAPI";
import { ParticaEvent } from "../../Models/ParticaEvent";

@Component(
	{
		name: "CustomerArticleLicenceForm",
		components: { ButtonList, LicenceBody }
	})
export default class CustomerArticleLicenceForm extends ParticaBaseForm<CustomerArticleLicenceDTO> {

	private nameconfig =
		{
			props: {
				name: "name",
				placeholder: "Enter name",
				label: "name",
			} as FormFieldProps,
			rules: { required: true, max: 50, min: 10, } as FormFieldRules
		} as IFormField;

	private descriptionconfig =
		{
			props: {
				name: "description",
				placeholder: "Enter description",
				label: "description",
			} as FormFieldProps,
			rules: { required: true, max: 500, min: 10, } as FormFieldRules
		} as IFormField;

	private bodyconfig =
		{
			props: {
				name: "body",
				placeholder: "Enter body",
				label: "body",
			} as FormFieldProps,
			rules: { required: true, max: 8000, min: 0, } as FormFieldRules
		} as IFormField;

	private eventHandler(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}
}
